import { CmpApiModel } from '../CmpApiModel.js';
export class Response {
    cmpId = CmpApiModel.cmpId;
    cmpVersion = CmpApiModel.cmpVersion;
    gdprApplies = CmpApiModel.gdprApplies;
    tcfPolicyVersion = CmpApiModel.tcfPolicyVersion;
}
